import { LANDSCAPE_IMAGE } from '../../../../fields'
import { getImageAssetInitialValues } from '../../helpers'

export const getInitialValues = assets => {
  return {
    [LANDSCAPE_IMAGE]: assets.map(asset => getImageAssetInitialValues(asset))
  }
}
